// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"c83b15fe","436":"a1cc8992","455":"0b863c0c","977":"240e71df"}[chunkId] + ".chunk.js";
};